import React, { Fragment, useState, useEffect } from "react";
import { Dropdown } from "react-bootstrap";
import { Link } from "react-router-dom";
import { SRLWrapper } from "simple-react-lightbox";
// import profile01 from "../../../../images/profile/1.jpg";
// import RctCollapsibleCard from "../RctCollapsibleCard/RctCollapsibleCard";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import { NotificationManager } from "react-notifications";
import MUIDataTable from "mui-datatables";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/Step";
import StepButton from "@material-ui/core/StepButton";
import { Form, FormGroup, Label, Input } from "reactstrap";
import Select from "react-select";
import {
  withGoogleMap,
  GoogleMap,
  withScriptjs,
  InfoWindow,
  Marker,
} from "react-google-maps";
import Autocomplete from "react-google-autocomplete";
import {
  Pagination,
  PaginationItem,
  PaginationLink,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";

import ReactPanZoom from "react-image-pan-zoom-rotate";
// import PageTitle from "../../../layouts/PageTitle";
import { setNestedObjectValues } from "formik";
import swalMessage from "@sweetalert/with-react";
import swal from "sweetalert";
import Switch from "@material-ui/core/Switch";
import { Col, Badge, Card, Row, Button, Container } from "react-bootstrap";
import Multiselect from "multiselect-react-dropdown";

import DeliveryMenu from './DeliveryMenu';
import CustomParallax from './CustomParallax';
import home_top from "./home_top.jpg";


const EcommerceMnt = () => {

  return (
    <>
      <>
        {/* <CustomParallax title='Deliveries' style={{ color: "black" }} img={home_top} height={300} /> */}
        <DeliveryMenu className='Delivery' />
      </>

    </>
  );
};
export default EcommerceMnt;
